export default {
    init: () => {
        const pageTitle = document.querySelector('head title').innerText;
        const isUserLoggedIn = localStorage.getItem('userSession');
        const username = localStorage.getItem('data.userSession.username');
        if ( pageTitle.indexOf('Sign In') < 0) {
            !isUserLoggedIn ? window.location.href = '/' : document.querySelector('nav a.mdl-navigation__link.text-center span').innerHTML = username;

            if ( document.querySelector('.profile-details') && isUserLoggedIn ) {
                const userProfile = document.querySelector('.profile-details');
                userProfile.querySelector('span.user').innerText = localStorage.getItem('data.userSession.username');
                const attributes = localStorage.getItem('data.userSession.attributes');
                const attr = JSON.parse(attributes);
                userProfile.querySelector('span.user-company').innerText = attr.agency;
                userProfile.querySelector('span.user-approvalLevel').innerText = localStorage.getItem('data.userSession.role');
            }
        } else {
            isUserLoggedIn ?  window.location.href = '/campaigns' : '';
        }
    }
};